import * as React from 'react'
import { Text, View } from 'react-native'
import styled from '@theme/styled-components'

import Header from '@components/header/Header'

const HeadersSection = () => {
  return (
    <Section>
      <SectionTitle>Headers</SectionTitle>

      <Container>
        <Header title="Title" />
      </Container>
      <Container>
        <Header
          title="Title"
          links={[
            { label: 'Link 1', onClick: () => undefined },
            { label: 'Link 2', onClick: () => undefined },
          ]}
        />
      </Container>
      <Container>
        <Header
          title="Title"
          links={[
            { label: 'Link 1', onClick: () => undefined },
            { label: 'Link 2', onClick: () => undefined },
          ]}
          description="Description"
        />
      </Container>
      <Container>
        <Header
          title="Title"
          links={[
            { label: 'Link 1', onClick: () => undefined },
            { label: 'Link 2', onClick: () => undefined },
          ]}
          buttons={[{ label: 'Button', onClick: () => undefined }]}
        />
      </Container>

      <Container>
        <Header
          title="Title"
          links={[
            { label: 'Link 1', onClick: () => undefined },
            { label: 'Link 2', onClick: () => undefined },
          ]}
          buttons={[
            { label: 'Button 1', onClick: () => undefined, color: 'light' },
            { label: 'Button 2', onClick: () => undefined },
          ]}
        />
      </Container>
      <Container>
        <Header
          title="Title"
          links={[
            { label: 'Link 1', onClick: () => undefined },
            { label: 'Link 2', onClick: () => undefined },
          ]}
          buttons={[{ label: 'Button', onClick: () => undefined }]}
          siteIcon="EGARCHE"
        />
      </Container>
    </Section>
  )
}

export default HeadersSection

const Section = styled(View)`
  border-color: ${(props) => props.theme.colors.disable};
  border-bottom-width: 1px;
  border-style: solid;
`
const SectionTitle = styled(Text)`
  padding: 24px;
  margin-bottom: 15px;
  text-decoration: underline;
  ${(props) => props.theme.fonts.LargeTitle};
`
const Container = styled(View)`
  margin-bottom: 12px;
`
